interface ObjectProps {
    [key: string]: any;
}

export default {
    namespace: 'freight',
    state: {
        editData: {},
    },
    reducers: {
        update(state: any, { payload }: ObjectProps) {
            return { ...state, ...payload };
        },
    },
    effects: {},
    subscriptions: {},
};
